/**
 * 外呼模块
 * **/
import {Message} from '@com.thunisoft.9law/element-ui';
import {createSingleVoiceCallTask, createVoiceCallTask, queryTaskDetailByCond, saveCallLog} from '@/assets/js/api';
import {s_to_hs} from '@/assets/js/utils';
import moment from 'moment';

import dataTable from '@/assets/js/dataTable';
const {CALL_STATUS} = dataTable;
export default {
  state: {
    seatInfo: {},
    // 正在拖拽
    startDrag: false,
    // 是否开启外呼功能
    openCall: false,
    viewState: '',
    // 外呼任务ID
    taskId: null,
    batchId: null,
    // 失联修复绑定的ID
    bindId: null,
    // 0：未初始化 1 初始化成功
    // 状态 1 初始化成功 => 2 正在拨通（60s）  => 3 无响应(3s)  4 号码异常(3s)  => 5 正在呼叫(30s) => 6 已接通 7 对方已挂断（3s） 8 无人接听(5s)
    // 呼入状态 0：未初始化 => 1 正在外呼 2：停止
    callStatus: CALL_STATUS['未初始化'],
    // 外呼计时器
    intervalCall: null,
    // 倒计时
    times: 0,
    // 通话时间
    callTimes: 0,
    // 来电信息
    callRing: {},
    // 外呼队列总数
    allNum: 0,
    // 外呼统计
    callNum: {
      sum: 0,
      called: 0,
      success: 0,
      fail: 0,
    },
    // 当前呼叫类型，1呼出 2呼入
    callType: 2,
    activeCallList: '1',
    // 当前呼叫状态
    workStatus: -1,
    destroyCall: true,
    // 失联修复
    missingRepair: null,
    repairBindData: {},
    activeCase: {},
    voiceCallDetails: {
      hasNext: false,
      nextPn: 1,
      total: 0,
      record: []
    },
    // 外呼埋点日志
    callLogs: [],
    // 拨打初始ID;
    startCaseId: ''
  },
  getters: {
    callTimes: (state) => {
      return s_to_hs(state.callTimes);
    },
    // 坐席正在占用
    isCalling: (state) => {
      return state.openCall || state.callStatus > CALL_STATUS['初始化成功'];
    }
  },
  mutations: {
    SEAT_INFO: (state, data) => {
      state.seatInfo = data;
    },
    SET_START_DRAG: (state, startDrag) => {
      state.startDrag = startDrag;
    },

    /**
     * @description 开启或关闭外呼功能
     * @param state
     * @param {Boolean} isOpen
     * @param {String} taskId
     * @param {String} bindId
     * @param {Number} callType
     * @param {String} batchId
     * @param {String} repairBindData
     * @param {String} activeCallList
     * @param {Number} sum 外呼总数
     */
    SET_OPEN_CALL: (state, {
      callType = 1, isOpen = true, taskId, bindId, batchId, repairBindData,
      activeCallList = '1',
    }) => {
      state.openCall = isOpen;
      state.taskId = taskId;
      state.bindId = bindId;
      state.callType = callType;
      state.batchId = batchId;
      state.callStatus = CALL_STATUS['未初始化'];
      state.activeCallList = activeCallList;
      state.repairBindData = repairBindData || {};
      if (isOpen) {
        state.destroyCall = false;
      }
    },
    SET_REPAIR_BIND_DATA: (state, {
      telX, bindId
    }) => {
      state.repairBindData.telX = telX;
      state.bindId = bindId;
      if (telX) {
        state.activeCase.telX = telX;
        if (state.voiceCallDetails.record && state.voiceCallDetails.record.length) {
          state.voiceCallDetails.record[0].telX = telX;
        }
      }
    },
    SET_REPAIR_STATUS: (state, status) => {
      if (state.missingRepair) {
        state.missingRepair.status = status;
        state.missingRepair.callStatus = status;
      }
      if (state.activeCase) {
        state.activeCase.status = status;
        state.activeCase.callStatus = status;
      }
      if (state.voiceCallDetails.record && state.voiceCallDetails.record.length) {
        state.voiceCallDetails.record[0].status = status;
        state.voiceCallDetails.record[0].callStatus = status;
      }
    },
    SET_ALL_NUM: (state, allNum) => {
      state.allNum = allNum;
    },
    SET_CALL_NUM: (state, _data) => {
      const {allNum} = state;
      Object.keys(_data)
        .forEach(key => {
          state.callNum[key] = _data[key];
        });
      if (allNum) {
        state.callNum.sum = allNum;
      }
    },
    UPDATE_CALL_NUM: (state, key) => {
      state.callNum[key] = state.callNum[key] + 1;
    },
    SET_CALL_TIMES: (state, callTimes) => {
      state.callTimes = callTimes;
      state.activeCase.callTimes = s_to_hs(callTimes);
    },
    // 设置当前呼叫类型
    DEL_ACTIVE_CALL(state, i) {
      state.voiceCallDetails.record.splice(i, 1);
    },
    SET_VIEW_STATE: (state, viewState) => {
      state.viewState = viewState;
    },
    SET_CALL_RING: (state, callRing) => {
      state.callRing = callRing;
    },
    // 设置当前坐席类型
    SET_DESTROY_CALL: (state, destroy) => {
      state.destroyCall = destroy;
    },
    SET_MISSING_REPAIR: (state, data) => {
      state.missingRepair = data;
    },
    SET_CALL_LIST: (state, data) => {
      state.voiceCallDetails.hasNext = data.hasNext;
      state.voiceCallDetails.total = data.total;
      state.voiceCallDetails.record = data.record;
      state.voiceCallDetails.nextPn = data.nextPn;
      const caseData = state.voiceCallDetails.record[0] || {};
      state.startCaseId = caseData.caseId;
    },
    UPDATE_CALL_LIST: (state, voiceCallDetails) => {
      const caseId = state.voiceCallDetails.record.slice(-1)[0].caseId;
      for (let i = 0; i < voiceCallDetails.record.length; i++) {
        if (caseId === voiceCallDetails.record[i].caseId) {
          voiceCallDetails.record.splice(0, i + 1);
          break;
        }
      }

      for (let i = 0; i < voiceCallDetails.record.length; i++) {
        if (state.startCaseId === voiceCallDetails.record[i].caseId) {
          voiceCallDetails.record.splice(i, voiceCallDetails.record.length);
          break;
        }
      }

      state.voiceCallDetails.record = state.voiceCallDetails.record.concat(voiceCallDetails.record);
      state.voiceCallDetails.hasNext = voiceCallDetails.hasNext;
      state.voiceCallDetails.nextPn = voiceCallDetails.nextPn;
    },
    SET_ACTIVE_CASE: (state, data) => {
      state.activeCase = data;
    },
    SET_ACTIVE_CALL_LIST: (state, activeCallList) => {
      state.activeCallList = activeCallList;
    },

    /**
     * @description 设置外呼状态
     * @param state
     * @param {number} status
     * @constructor
     */
    SET_CALL_STATUS: (state, status) => {
      state.callStatus = status;
    },
    SET_INTERVAL_CALL: (state, times) => {
      if (state.intervalCall) {
        clearInterval(state.intervalCall);
        state.intervalCall = null;
      }
      state.times = times;
      state.intervalCall = setInterval(() => {
        if (state.times <= 0) {
          clearInterval(state.intervalCall);
          state.intervalCall = null;
          state.times = 0;
          return;
        }
        state.times--;
      }, 1000);
    },
    ADD_CALL_LOG(state, log) {
      let taskTime = moment(log.endTime)
        .valueOf() - moment(log.startTime)
        .valueOf();
      let ringingTime = moment(log.callTime20)
        .valueOf() - moment(log.callTime5)
        .valueOf();
      if (isNaN(taskTime)) {
        taskTime = '';
      }
      if (isNaN(ringingTime)) {
        ringingTime = '';
      }
      state.callLogs.push({
        // 外呼任务id
        taskId: state.taskId,
        // 失联修复Id
        bindId: state.bindId,
        // 任务时长
        taskTime,
        // 振铃响应时间 > 5s 判定异常
        ringingTime,
        ...log
      });
    },
    Clear_CALL_LOG(state) {
      state.callLogs = [];
    },
    CLEAR_CALL_DATA(state, callStatus) {
      if(callStatus) {
        state.callStatus = callStatus;
      }
      sessionStorage.removeItem('initNewVoiceCallControllerTime');
      state.callType = 2;
      state.openCall = false;
      state.viewState = '';
      state.callNum = {
        sum: 0,
        called: 0,
        success: 0,
        fail: 0,
      };
      state.activeCase = {};
      state.voiceCallDetails = {
        hasNext: false,
        nextPn: 1,
        total: 0,
        record: []
      };
    },
    SET_ACTIVE_CALL_STATUS(state, status) {
      state.activeCase.callStatus = status;
      state.voiceCallDetails.record[0].callStatus = status;
      // state.voiceCallDetails.record.forEach(item => {
      //   console.log(item, state.activeCase);
      //   if (item.voiceCallId === state.activeCase.voiceCallId) {
      //     item.callStatus = status;
      //   }
      // });
    }
  },
  actions: {

    /**
     * @description 通话时长
     * @param commit
     * @param state
     * @param stop
     * @constructor
     */
    StartCallTimes({
      commit, state
    }, stop) {
      commit('SET_CALL_TIMES', 0);
      if (this.intervalCall) {
        clearInterval(this.intervalCall);
        this.intervalCall = null;
      }
      if (stop) {
        return;
      }
      this.intervalCall = setInterval(() => {
        const callTimes = state.callTimes + 1;
        commit('SET_CALL_TIMES', callTimes);
      }, 1000);
    },
    // 保存失联修复数据
    SetMissingRepair({commit}, _data) {
      const data = {..._data};
      if (!data.status) {
        data.status = '1';
      }
      commit('SET_MISSING_REPAIR', data);
      commit('SET_REPAIR_STATUS', data.status);
    },
    async UpdateCallList({
      commit, state
    }) {
      if (state.voiceCallDetails.hasNext) {
        const {record} = state.voiceCallDetails;
        const length = record.length;
        let num = 0;
        for (let i = length; i > 0; i--) {
          num++;
          if (num > 10 || record[i - 1].caseId === state.activeCase.caseId) {
            break;
          }
        }
        console.log(num);
        if (num < 11) {
          const {
            code, data
          } = await queryTaskDetailByCond({
            order: 2,
            batchId: state.batchId || '',
            taskId: state.taskId,
            taskType: 2,
            status: state.activeCallList,
            pageNo: 1 || state.voiceCallDetails.nextPn,
            pageSize: 20,
            query: {
              batchName: state.voiceCallDetails.record[state.voiceCallDetails.record.length - 1].voiceCallId
            }
          });
          if (code === 200) {
            commit('UPDATE_CALL_LIST', data.voiceCallDetails);
          }
        }
      }
    },
    QueryCallList({
      commit, state
    }, params = {}) {
      commit('SET_CALL_LIST', {
        hasNext: false,
        nextPn: 1,
        total: 0,
        record: []
      });
      return new Promise(async (resolve, reject) => {
        const status = params.status || state.activeCallList;
        commit('SET_ACTIVE_CALL_LIST', status);
        // 有bindId说明是失联修复
        if (state.bindId) {
          let record = [];
          const currentStatus = state.missingRepair ? state.missingRepair.status || '1' : '1';
          if (status === '1' && !['2', '3'].includes(currentStatus)) {
            record = [{
              ...state.missingRepair,
              callStatus: currentStatus
            }];
          }
          if (status === '2' && currentStatus === '2') {
            record = [{
              ...state.missingRepair,
              callStatus: currentStatus
            }];
          }
          if (status === '3' && currentStatus === '3') {
            record = [{
              ...state.missingRepair,
              callStatus: currentStatus
            }];
          }
          commit('SET_CALL_LIST', {
            hasNext: false,
            nextPn: 1,
            record,
            total: record.length,
            totalPage: 1
          });
          commit('SET_ACTIVE_CASE', record[0] || {});
          resolve();
        } else {
          const {
            code, data, msg
          } = await queryTaskDetailByCond({
            order: 2, // 1，根据案号排序，2：更具更新时间排序。
            batchId: state.batchId || '',
            taskId: state.taskId,
            taskType: 2, // 任务类型，1：短信，2：外呼
            status, // 状态,1:未拨打，2：已拨打，3：未接通
            pageNo: 1,
            pageSize: 20,
            query: {
              batchName: ''
            },
            ...params
          });
          if (code === 200) {
            const voiceCallDetails = data.voiceCallDetails;
            commit('SET_CALL_LIST', voiceCallDetails);
            let activeCase = {};
            if (state.voiceCallDetails.total) {
              activeCase = voiceCallDetails.record[0];
            }
            commit('SET_ACTIVE_CASE', activeCase);
            resolve(voiceCallDetails);
          } else {
            Message.error(msg || '获取外呼队列失败，请重试');
            reject();
          }
        }
      });
    },

    /**
     * @description 开启外呼功能
     * @param commit
     * @param _data
     * @returns {Promise<void>}
     * @constructor
     */
    async SetOpenCall({commit}, _data) {
      commit('SET_OPEN_CALL', {
        isOpen: false,
        callType: 2
      });

      let result;
      if (_data.isSingle) {
        result = await createSingleVoiceCallTask(_data);
      } else {
        result = await createVoiceCallTask(_data);
      }
      if (result.code === 200 && result.data) {
        commit('SET_OPEN_CALL', {
          isOpen: _data.isOpen,
          batchId: _data.batchId,
          taskId: result.data
        });
      } else {
        Message.error(result.msg || '创建外呼队列失败，请重试');
      }
    },
    SendLogs({
      state, commit
    }, send) {
      const {length} = state.callLogs;
      if (!length) {
        return;
      }
      if (length >= 20 || send) {
        saveCallLog(state.callLogs)
          .then(({code}) => {
            if (code === 200) {
              commit('Clear_CALL_LOG');
            }
          });
      }
    },
  }
};
